<template>
  <xm-page class="pro-list-page">
    <div  class="fd-column" style="height:100%">
      <van-search v-if="groupList.length !== 0" v-model="searchValue" shape="round" placeholder="搜索商品" @focus="toSearch" class="zIndex" />
      <van-tabs v-if="commodityGroupList.length > 0" @click="onClickTab" :ellipsis="false" swipe-threshold="3" class="zIndex" >
        <van-tab title="全部"></van-tab>
        <van-tab v-for="(item, index) in commodityGroupList" v-show="item.commodityNumber !== 0" :key="index" :title="item.name"></van-tab>
      </van-tabs>
      <xm-scroll
        v-show="groupList.length > 0"
        :on-refresh="onRefresh"
        :on-infinite="onInfinite"
        :class="`position-group ${commodityGroupList.length === 0 ? 'no' : 'yes'}`"
        :enableInfinite="hasMore"
        id="content"
      >
        <div v-if="hotSellList.length > 0 && tabValue === 0" class="recommend" style="marginTop:0.24rem">
          <div class="header">
            <div class="title ">推荐</div>
            <div class="more" @click="toRecommend()">更多<span class="icon iconfont" style="font-size:0.2rem">&#xe611;</span></div>
          </div>
          <ul class="content" @touchmove.stop>
            <li class="item" v-for="(item, index) in hotSellList" @click="toProDetail(item.id)" :key="index">
              <div class="avatar">
                <img :src="item.coverResource.resUrl || goodsDefaultImg[item.category]" alt="" />
                <span v-if="item.coverCornerMark" :class="`corner-mark ${!MARKS.includes(item.coverCornerMark) ? 'customer' : item.coverCornerMark}`">
                  {{ !MARKS.includes(item.coverCornerMark) ? item.coverCornerMark : '' }}
                </span>
              </div>
              <span class="desc">
                <span class="name">
                  {{ item.commodityAlias }}
                </span>
              </span>
              <div class="footer">
                <div class="price-con" v-if="item.category === 'COURSE'">
                  <span class="origin-price">
                    ¥{{ sortCoursePrice(item.coursePrices) }}
                    <span v-if="item.coursePrices.length > 1">起</span>
                  </span>
                  <span
                    v-if="
                      sortUnderlinePrice(item.coursePrices) &&
                        sortUnderlinePrice(item.coursePrices) !== 0 &&
                        sortUnderlinePrice(item.coursePrices) !== sortCoursePrice(item.coursePrices)
                    "
                  >
                    <span class="line-price"> ¥{{ sortUnderlinePrice(item.coursePrices) }}</span
                    ><span class="line-price" v-if="item.coursePrices.length > 1">起</span>
                  </span>
                </div>
                <div class="price-con" v-if="item.category === 'SUITE'">
                  <span class="origin-price">¥{{ item.commodityPrice }}</span>
                  <span v-if="item.underlinePrice && item.underlinePrice !== 0 && item.commodityPrice !== item.underlinePrice" class="line-price">
                    ¥{{ item.underlinePrice }}
                  </span>
                </div>
                <div class="price-con" v-if="item.category === 'GOODS' || item.category === 'FEE_ITEM'">
                  <span class="origin-price">¥{{ item.commodityPrice }}</span>
                  <span v-if="item.underlinePrice && item.underlinePrice !== 0 && item.commodityPrice !== item.underlinePrice" class="line-price">
                    ¥{{ item.underlinePrice }}
                  </span>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div v-if="groupList.length > 0" class="commodity">
          <div class="flex-between" style="marginTop:0.24rem">
            <ul class="row">
              <li v-for="(item, index) in groupList" :key="index" @click="toProDetail(item.id)" v-show="index % 2 === 0">
                <div class="avatar">
                  <img :src="item.coverResource.resUrl || goodsDefaultImg[item.category]" alt />
                  <span v-if="item.coverCornerMark" :class="`corner-mark ${!MARKS.includes(item.coverCornerMark) ? 'customer' : item.coverCornerMark}`">
                    {{ !MARKS.includes(item.coverCornerMark) ? item.coverCornerMark : '' }}
                  </span>
                </div>
                <div class="desc">
                  <span class="tag">
                    <span class="item" v-if="item.category === 'COURSE'">课程</span>
                    <span class="item" v-if="item.category === 'GOODS'">物品</span>
                    <span class="item" v-if="item.category === 'FEE_ITEM'">费用</span>
                    <span class="item" v-if="item.category === 'SUITE'">套餐</span>
                  </span>
                  <span class="name">{{ item.commodityAlias }}</span>
                </div>
                <div class="footer">
                  <div class="price-con" v-if="item.category === 'COURSE'">
                    <span class="origin-price">
                      ¥{{ sortCoursePrice(item.coursePrices) }}
                      <span v-if="item.coursePrices.length > 1">起</span>
                    </span>
                    <span
                      v-if="
                        sortUnderlinePrice(item.coursePrices) &&
                          sortUnderlinePrice(item.coursePrices) !== 0 &&
                          sortUnderlinePrice(item.coursePrices) !== sortCoursePrice(item.coursePrices)
                      "
                    >
                      <span class="line-price"> ¥{{ sortUnderlinePrice(item.coursePrices) }}</span
                      ><span class="line-price" v-if="item.coursePrices.length > 1">起</span>
                    </span>
                  </div>
                  <div class="price-con" v-if="item.category === 'SUITE'">
                    <span class="origin-price">¥{{ item.commodityPrice }}</span>
                    <span v-if="item.underlinePrice && item.underlinePrice !== 0 && item.commodityPrice !== item.underlinePrice" class="line-price">
                      ¥{{ item.underlinePrice }}
                    </span>
                  </div>
                  <div class="price-con" v-if="item.category === 'GOODS' || item.category === 'FEE_ITEM'">
                    <span class="origin-price">¥{{ item.commodityPrice }}</span>
                    <span v-if="item.underlinePrice && item.underlinePrice !== 0 && item.commodityPrice !== item.underlinePrice" class="line-price">
                      ¥{{ item.underlinePrice }}
                    </span>
                  </div>
                </div>
              </li>
            </ul>
            <ul class="row">
              <li v-for="(item, index) in groupList" :key="index" @click="toProDetail(item.id)" v-show="index % 2 !== 0">
                <div class="avatar">
                  <img :src="item.coverResource.resUrl || goodsDefaultImg[item.category]" alt />
                  <span v-if="item.coverCornerMark" :class="`corner-mark ${!MARKS.includes(item.coverCornerMark) ? 'customer' : item.coverCornerMark}`">
                    {{ !MARKS.includes(item.coverCornerMark) ? item.coverCornerMark : '' }}
                  </span>
                </div>
                <div class="desc">
                  <span class="tag">
                    <span class="item" v-if="item.category === 'COURSE'">课程</span>
                    <span class="item" v-if="item.category === 'GOODS'">物品</span>
                    <span class="item" v-if="item.category === 'FEE_ITEM'">费用</span>
                    <span class="item" v-if="item.category === 'SUITE'">套餐</span>
                  </span>
                  <span class="name">{{ item.commodityAlias }}</span>
                </div>
                <div class="footer">
                  <div class="price-con" v-if="item.category === 'COURSE'">
                    <span class="origin-price">
                      ¥{{ sortCoursePrice(item.coursePrices) }}
                      <span v-if="item.coursePrices.length > 1">起</span>
                    </span>
                    <span
                      v-if="
                        sortUnderlinePrice(item.coursePrices) &&
                          sortUnderlinePrice(item.coursePrices) !== 0 &&
                          sortUnderlinePrice(item.coursePrices) !== sortCoursePrice(item.coursePrices)
                      "
                    >
                      <span class="line-price"> ¥{{ sortUnderlinePrice(item.coursePrices) }}</span
                      ><span class="line-price" v-if="item.coursePrices.length > 1">起</span>
                    </span>
                  </div>
                  <div class="price-con" v-if="item.category === 'SUITE'">
                    <span class="origin-price">¥{{ item.commodityPrice }}</span>
                    <span v-if="item.underlinePrice && item.underlinePrice !== 0 && item.commodityPrice !== item.underlinePrice" class="line-price">
                      ¥{{ item.underlinePrice }}
                    </span>
                  </div>
                  <div class="price-con" v-if="item.category === 'GOODS' || item.category === 'FEE_ITEM'">
                    <span class="origin-price">¥{{ item.commodityPrice }}</span>
                    <span v-if="item.underlinePrice && item.underlinePrice !== 0 && item.commodityPrice !== item.underlinePrice" class="line-price">
                      ¥{{ item.underlinePrice }}
                    </span>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div v-if="!hasMore" class="bottom-tip">已经到底了～</div>
        </div>
      </xm-scroll>
      <div v-if="groupList.length === 0" class="down-con df-c" style="flex: 1">
        <div>
          <img src="https://image.xiaomaiketang.com/xm/ZCwzpFzsiX.png" class="down-img" />
          <div class="tip">商品赶来中，敬请期待</div>
        </div>
      </div>
    </div>
    
    <div class="micro-entry-box" @click="handleLinkToMicroSite">
      <div class="micro-entry">
        <img src="https://image.xiaomaiketang.com/xm/d72h2iH5H7.png" alt="" />
      </div>
    </div>
    <micro-site-modal
      v-if="modalVisible"
      :data="{
        currentXcxCodeUrl: this.currentXcxCodeUrl,
        currentItem: { instName: this.$route.query.instName },
        fromOrigin: 'product-list',
        close: this.closeMicroSiteModal,
      }"
    />
  </xm-page>
</template>
<script>
import Platform from '@/core/platform';
import WechatApi from '@/core/wechatApi';
import User from '@/core/user';
import InstService from '../../service/InstitutionService';
import ShareService from '@/service/ShareService';
import MicroSiteModal from '../../components/MicroSiteModal';
import { joinAddress } from '@/core/util';

export default {
  components: {
    'micro-site-modal': MicroSiteModal,
  },
  data() {
    return {
      MARKS: ['NEW', 'TIME', 'PRIVI'],
      goodsDefaultImg: {
        COURSE: 'https://image.xiaomaiketang.com/xm/internal/eMdhFaJ3NF.png',
        GOODS: 'https://image.xiaomaiketang.com/xm/internal/BebQYQSnHz.png',
        FEE_ITEM: 'https://image.xiaomaiketang.com/xm/internal/BGDFZxjSzk.png',
        SUITE: 'https://image.xiaomaiketang.com/xm/internal/3XhA6MQnSG.png',
      },
      commodityGroupList: [],
      groupId: '',
      inst: {},
      hotSellList: [],
      hasMore: false,
      reload: false,
      marketingStatus: false, // 微官网关联入口开启状态
      modalVisible: false, // 微官网太阳码模态框
      currentXcxCodeUrl: null,
      searchValue: '',
      tabValue: 0,
      current: 1,
      size: 20,
      groupList: [],
    };
  },
  mounted() {
    const title = this.$route.query.instName;
    if (Platform.isAlipay()) {
      AlipayJSBridge.call('setTitle', { title });
    } else {
      document.title = title;
    }

    this.fetchCommodityGroup();
    this.fetchGroupList();
    this.fetchInstData();
    this.fetchHotSellCommodityList();
  },

  methods: {
    onClickTab(index) {
      this.tabValue = index;
      this.groupList = [];
      this.current = 1;
      this.fetchGroupList();
      if (index === 0) {
        this.fetchHotSellCommodityList();
      }
      document.getElementById('content').scrollTop = 0;
    },
    // 获取商品列表
    fetchGroupList(done) {
      const { size, current } = this;
      const params = {
        size,
        current,
        instId: this.$route.query.instId,
        commodityGroupId: this.tabValue !== 0 ? this.commodityGroupList[this.tabValue - 1].id : '',
      };
      axios.Customer('anon/mall/fetchPageOfCommodity', params).then(res => {
        if (res.success) {
          this.hasMore = false;
          const { result = {} } = res;
          const { records = [] } = result;
          console.log('商品列表', records);
          if (res.data.records && res.data.records.length === size) {
            this.current++;
            this.hasMore = true;
          }
          const list = current > 1 ? [...this.groupList, ...records] : records;
          this.groupList = list;
          done && done();
        }
      });
    },
    closeMicroSiteModal() {
      this.modalVisible = false;
    },
    handleLinkToMicroSite() {
      const instId = this.$route.query.instId;
      InstService.getMarketingStatus({
        instId,
      }).then(res => {
        this.marketingStatus = res.result;
        if (this.marketingStatus) {
          this.modalVisible = true;
          const params = {
            scene: JSON.stringify({ instId }),
          };
          let serverPath = drServer || window.CONFIG.server;
          if (SERVER) {
            serverPath = drServer || SERVER;
          }
          InstService.generateCodeUrl(params).then(res => {
            const currentXcxQrcode = `${SERVER || window.CONFIG.server}sales/anon/commonMicroWebsite/getXcxCode?scene=${res.result}`;
            this.currentXcxCodeUrl = currentXcxQrcode;
          });
        } else {
          window.router.push({
            name: 'inst_home',
            query: { id: instId, fromP: true },
          });
        }
      });
    },

    // 获取商品分组
    fetchCommodityGroup() {
      const params = {
        instId: this.$route.query.instId,
      };
      axios.Customer('anon/commodity/listCommodityGroup', params).then(res => {
        if (res.success) {
          this.commodityGroupList = res.result.filter(item => {
            return item.commodityNumber !== 0;
          });
        }
      });
    },

    // 获取推荐商品列表
    fetchHotSellCommodityList() {
      const params = {
        instId: this.$route.query.instId,
      };
      axios.Customer('anon/mall/fetchHotSellCommodityList', params).then(res => {
        if (res.success) {
          console.log('推荐商品列表', res.result);
          this.hotSellList = res.result.slice(0, 5);
        }
      });
    },

    doShare() {

      const name =  this.$route.query.instName && this.$route.query.instName !== '在线商城' ? this.$route.query.instName:'' ;
      WechatApi.doWapShare({
        title: `${name}在线商城全面上线，优质商品等您选购`,
        desc: '点击进入商城，了解更多',
        linkUrl:
          location.origin +
          location.pathname +
          '#/online/product/list?instId=' +
          this.$route.query.instId +
          '&instName=' +
          window.encodeURIComponent(this.$route.query.instName) +
          '&appId=' +
          (this.$route.query.appId || User.appId()) ,
        imgUrl: this.inst.banner || 'https://image.xiaomaiketang.com/xm/N4AQhzkkPR.png',
      });
      wx.miniProgram.postMessage({
        data: {
          title: `${name}在线商城全面上线，优质商品等您选购`,
          desc: '点击进入商城，了解更多',
          linkUrl:
            location.origin +
            location.pathname +
            '#/online/product/list?instId=' +
            this.$route.query.instId +
            '&instName=' +
            window.encodeURIComponent(this.$route.query.instName) +
            '&appId=' +
            (this.$route.query.appId || User.appId()) ,
          imgUrl: this.inst.banner || 'https://image.xiaomaiketang.com/xm/N4AQhzkkPR.png',
        },
      });
    },
    sortCoursePrice(theArr) {
      let theSmallPrice = theArr[0].totalPrice;
      for (var i = 0; i < theArr.length; i++) {
        if (theSmallPrice > theArr[i].totalPrice) {
          theSmallPrice = theArr[i].totalPrice;
        }
      }
      return theSmallPrice;
    },
    sortUnderlinePrice(theArr) {
      let theSmallUnderlinePrice = 0;
      for (let i = 0; i < theArr.length; i++) {
        if (theArr[i].underlinePrice && theArr[i].underlinePrice !== 0) {
          theSmallUnderlinePrice = theArr[i].underlinePrice;
          break;
        }
      }
      for (let j = 0; j < theArr.length; j++) {
        if (theSmallUnderlinePrice > theArr[j].underlinePrice && theArr[j].underlinePrice !== 0) {
          theSmallUnderlinePrice = theArr[j].underlinePrice;
        }
      }
      return theSmallUnderlinePrice;
    },
    fetchInstData() {
      const id = this.$route.query.instId;
      ShareService.getShareInstDetail(id).then(res => {
        const { addressCode } = res.result;
        const address = joinAddress(addressCode);
        this.inst = {
          ...res.result,
          address,
        };
        this.doShare();
      });
    },

    toProDetail(commodityId) {
      window.router.push({
        name: 'online_product_detail',
        query: {
          instId: this.$route.query.instId,
          instName: this.$route.query.instName,
          commodityId,
        },
      });
    },
    toRecommend() {
      window.router.push({
        name: 'online_recommend',
        query: {
          instId: this.$route.query.instId,
          instName: this.$route.query.instName,
          banner: this.inst.banner,
        },
      });
    },
    toSearch() {
      window.router.push({
        name: 'online_search',
        query: {
          instId: this.$route.query.instId,
          instName: this.$route.query.instName,
          banner: this.inst.banner,
        },
      });
    },
    onRefresh(done) {
      this.current = 1;
      this.fetchGroupList(done);
      if (this.tabValue === 0) {
        this.fetchHotSellCommodityList();
      }
    },
    onInfinite(done) {
      this.fetchGroupList(done);
    },
  },
};
</script>
<style lang="less">
@import url(../../core/mixins.less);
.pro-list-page {
  .van-tabs--line{
    .van-tabs__wrap{
      height: 0.92rem;
    }
  } 
  .line {
    width: 100%;
    height: 0.04rem;
    background: #eeeeee;
  }
  .zIndex {
    z-index: 1000;
  }
  .nav {
    background-color: #ffffff;
    padding: 0 0.32rem;
    height: 0.96rem;
    line-height: 0.96rem;
    margin-bottom: 0.2rem;
    text-align: left;
    display: flex;
    .tab-item {
      flex: 1;
      text-align: center;
      font-size: 0.3rem;
      color: #333333;
    }
    .active-item {
      color: #ff6934;
      border-bottom: 0.04rem solid #ff6934;
    }
  }
  .position-group {
    &.yes {
      position: fixed;
      top: 2rem;
    }
    &.no {
      position: fixed;
      top: 1.1rem;
    }
  }
  .recommend {
    width: 6.86rem;
    background: #ffffff;
    border-radius: 0.16rem;
    margin: 0 auto;
    padding: 0.32rem 0.24rem 0;
    .header {
      display: flex;
      justify-content: space-between;
      margin-bottom: 0.24rem;
      .title {
        font-size: 0.3rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 0.42rem;
      }
      .more {
        font-size: 0.24rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 0.34rem;
      }
    }
    .content {
      list-style: none;
      overflow-x: scroll;
      white-space: nowrap;
      display: -webkit-box;
      .item {
        width: 2.5rem;
        background: #fff;
        border-radius: 0.16rem;
        margin-right: 0.32rem;
        .avatar {
          width: 100%;
          position: relative;
          border-radius: 0.16rem;
          overflow: hidden;
          > img {
            display: block;
            width: 100%;
          }
        }
        .desc {
          display: flex;
          padding: 0.18rem 0.2rem 0;
          margin-bottom: 0.16rem;
          .name {
            // height: 0.72rem;
            color: #4a4a4a;
            font-size: 0.26rem;
            line-height: 0.36rem;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            overflow: hidden;
            text-overflow: ellipsis;
            max-height: 1.14rem;
            -webkit-box-orient: vertical;
          }
        }
        .footer {
          padding: 0 0.2rem;

          .price-con {
            margin-bottom: 0.12rem;
            .origin-price {
              font-size: 0.3rem;
              color: #ff6934;
              line-height: 0.42rem;
              font-weight: 500;
            }
            .line-price {
              font-size: 0.22rem;
              color: #999999;
              line-height: 0.32rem;
              text-decoration: line-through;
            }
          }
        }
      }
      .item:last-child {
        margin-right: 0;
      }
    }
    .content::-webkit-scrollbar {
      width: 0;
    }
    .person-wrap {
      // width: 100%;
      height: 4.16rem;
      overflow: hidden;
    }
    .recommend-commodity {
      display: -webkit-box;
      // overflow-x: auto;
      // overflow: hidden;
      li {
        width: 2.5rem;
        background: #fff;
        border-radius: 0.16rem;
        margin-right: 0.32rem;
        .avatar {
          width: 100%;
          position: relative;
          border-radius: 0.16rem;
          overflow: hidden;
          > img {
            display: block;
            width: 100%;
          }
        }
        .desc {
          display: flex;
          padding: 0.18rem 0.2rem 0;
          margin-bottom: 0.16rem;
          .name {
            // height: 0.72rem;
            color: #4a4a4a;
            font-size: 0.26rem;
            line-height: 0.36rem;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            overflow: hidden;
            text-overflow: ellipsis;
            max-height: 1.14rem;
            -webkit-box-orient: vertical;
          }
        }
        .footer {
          padding: 0 0.2rem;

          .price-con {
            margin-bottom: 0.12rem;
            .origin-price {
              font-size: 0.3rem;
              color: #ff6934;
              line-height: 0.42rem;
              font-weight: 500;
            }
            .line-price {
              font-size: 0.22rem;
              color: #999999;
              line-height: 0.32rem;
              text-decoration: line-through;
            }
          }
        }
      }
      li:last-child {
        margin-right: 0;
      }
    }
  }
  .commodity {
    width: 6.86rem;
    margin: 0 auto;
    .row {
      display: flex;
      flex-direction: column;
      li {
        width: 3.32rem;
        height: auto;
        background: #ffffff;
        border-radius: 0.16rem;
        margin-bottom: 0.24rem;
        overflow: hidden;
        .avatar {
          width: 3.32rem;
          height: 3.32rem;
          position: relative;
          overflow: hidden;
          > img {
            display: block;
            width: 100%;
            overflow: hidden;
            border-radius: 0.16rem 0.16rem 0 0;
          }
        }
        .desc {
          padding: 0.18rem 0.2rem 0;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          overflow: hidden;
          text-overflow: ellipsis;
          max-height: 1.14rem;
          -webkit-box-orient: vertical;
          .tag {
            .item {
              padding: 0 0.08rem;
              font-size: 0.22rem;
              line-height: 0.32rem;
              color: #ff6934;
              border: 0.01rem solid #ff6934;
            }
          }
          .name {
            color: #4a4a4a;
            font-size: 0.26rem;
            line-height: 0.36rem;
          }
        }
        .footer {
          padding: 0 0.2rem;
          margin-bottom: 0.18rem;
          .price-con {
            .origin-price {
              font-size: 0.3rem;
              color: #ff6934;
              line-height: 0.42rem;
              font-weight: 500;
            }
            .line-price {
              font-size: 0.22rem;
              color: #999999;
              line-height: 0.32rem;
              text-decoration: line-through;
            }
          }
        }
      }
    }
  }
  .corner-mark {
    position: absolute;
    top: -0.01rem;
    right: -0.01rem;
    display: inline-block;
    min-width: 0.84rem;
    height: 0.4rem;

    &.NEW {
      background: url('https://image.xiaomaiketang.com/xm/internal/WSnp5PDW2D.png') no-repeat center;
      background-size: 42px 20px;
    }
    &.TIME {
      background: url('https://image.xiaomaiketang.com/xm/internal/TJWkdia7wH.png') no-repeat center;
      background-size: 42px 20px;
    }
    &.PRIVI {
      background: url('https://image.xiaomaiketang.com/xm/internal/iaS4shyHSJ.png') no-repeat center;
      background-size: 42px 20px;
    }

    &.customer {
      font-weight: 600;
      box-sizing: border-box;
      height: 0.4rem;
      padding: 0 0.16rem;
      color: #fff;
      font-size: 0.22rem;
      line-height: 0.4rem;
      vertical-align: top;
      background: linear-gradient(90deg, #ff8625 0%, #f24f67 100%);
      background-color: #ccc;
      border-radius: 0.04rem;
    }
  }
  .down-con {
    .down-img {
      width: 2.24rem;
      height: 1.54rem;
      display: inline-block;
    }
    .tip {
      font-size: 0.26rem;
      color: rgba(153, 153, 153, 1);
      line-height: 0.36rem;
    }
  }
  .bottom-tip {
    color: #999;
  }
  .micro-site-modal {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(224, 237, 255, 1);
    .micro-site-modal-content {
      width: 6.8rem;
      height: 7.8rem;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
      border-radius: 12px;
      margin: 40px auto;
      padding: 0.6rem;
      .code-box {
        border-bottom: 1px dashed rgba(232, 232, 232, 1);
        .top-text {
          margin-bottom: 0.04rem;
        }
        img {
          width: 3.6rem;
          height: 3.6rem;
          margin: 0 auto;
        }
      }
      .inst-desc {
        margin-top: 0.3rem;
        text-align: left;
        .inst-name {
          .institution-name {
            height: 0.48rem;
            font-size: 0.34rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(57, 70, 85, 1);
            line-height: 0.48rem;
          }
        }
      }
    }
  }
  .micro-entry-box {
    position: fixed;
    bottom: 3.8rem;
    right: 0.2rem;
    z-index: 1001;
    .micro-entry {
      width: 1.16rem;
      height: 1.16rem;
      border-radius: 50%;
      z-index: 10001;
      img {
        width: 1.16rem;
        height: 1.16rem;
      }
    }
  }
  .page-tab-container {
    .scrollTop {
      top: 2.4rem;
    }
    .scroll-inner {
      top: 0;
    }
    .commodity {
      display: flex;
      flex-direction: column;
      li {
        width: 3.32rem;
        height: auto;
        background: #ffffff;
        border-radius: 0.16rem;
        margin-bottom: 0.24rem;
        position: relative;
        .avatar {
          overflow: hidden;
          width: 3.32rem;
          height: 3.32rem;
          > img {
            display: block;
            width: 100%;
            overflow: hidden;
            border-radius: 0.16rem 0.16rem 0 0;
          }
        }
        .desc {
          padding: 0.18rem 0.2rem 0;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          overflow: hidden;
          text-overflow: ellipsis;
          max-height: 1.14rem;
          -webkit-box-orient: vertical;
          .tag {
            .item {
              padding: 0 0.08rem;
              font-size: 0.22rem;
              line-height: 0.32rem;
              color: #ff6934;
              border: 0.01rem solid #ff6934;
            }
          }
          .name {
            color: #4a4a4a;
            font-size: 0.26rem;
            line-height: 0.36rem;
          }
        }
        .footer {
          padding: 0 0.2rem;
          margin-bottom: 0.18rem;
          .price-con {
            .origin-price {
              font-size: 0.3rem;
              color: #ff6934;
              line-height: 0.42rem;
              font-weight: 500;
            }
            .line-price {
              font-size: 0.22rem;
              color: #999999;
              line-height: 0.32rem;
              text-decoration: line-through;
            }
          }
        }
      }
    }
    .product-item {
      li {
        display: flex;
        margin: 0 0.32rem 0.2rem 0.32rem;
        align-items: center;

        .avatar {
          overflow: hidden;
          width: 2rem;
          > img {
            display: block;
            height: 2rem;
            width: 2rem;
            border-radius: 0.1rem 0 0 0.1rem;
          }
        }
        .desc {
          flex: 1;
          background: #fff;
          padding: 0 0.24rem;
          height: 2rem;
          border-radius: 0 0.1rem 0.1rem 0;
          .name-tag {
            height: 1.2rem;
            .name {
              margin: 0.16rem 0 0 0;
              color: #4a4a4a;
              font-size: 0.26rem;
              // height: 0.72rem;
              line-height: 0.36rem;
              font-weight: 500;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
            }
            .tag {
              .item {
                padding: 0 0.08rem;
                font-size: 0.22rem;
                line-height: 0.32rem;
                color: #999999;
                border: 0.5px solid #dddddd;
              }
            }
          }
          .footer {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .price-con {
              .origin-price {
                font-size: 0.3rem;
                color: #ff6934;
                line-height: 0.42rem;
                font-weight: 500;
              }
              .line-price {
                font-size: 0.22rem;
                color: #999999;
                line-height: 0.32rem;
                text-decoration: line-through;
              }
            }
            .buy-btn {
              padding: 0.1rem 0.2rem;
              font-size: 0.22rem;
              line-height: 0.32rem;
              height: auto;
              color: #ffffff;
              background-color: #ff6a30;
              border-radius: 0.29rem;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/module/mall/ProductList.vue